import React from "react";
import { useNavigate } from "react-router-dom";
import styles from "./MiddleBlock.module.css";
import MuiButton from "@mui/material/Button";
import illustration from "../../../assets/img/online-education.png";

const MiddleBlock = ({ title, content, button, navLink }) => {
  const navigate = useNavigate();

  return (
    <section className={styles.heroSection}>
      <div className={styles.heroContainer}>
        <div className={styles.heroText}>
          <p className={styles.subheading}>START FROM TODAY!</p>
          <h1 className={styles.heading}>{title}</h1>
          <p className={styles.description}>{content}</p>
          <MuiButton
            className={styles.heroButton}
            onClick={() => navigate(navLink || "/Courses")}
            variant="contained"
          >
            {button}
          </MuiButton>
        </div>

        <div className={styles.heroImage}>
          <img src={illustration} alt="Online Education" />
        </div>
      </div>
    </section>
  );
};

export default MiddleBlock;
